import titleAndDescription from './TitleAndDescription';
import mainCharts from './MainCharts';
import progressCharts from './ProgressCharts';

export default [titleAndDescription, mainCharts, progressCharts];
